export default __webpack_public_path__ + "static/media/success-img.b376037b.jpg";